/** Untrusted request metadata: a known named zone, never a fixed offset or prose. */
export function validChatTimeZone(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.length > 100 || !/^[A-Za-z][A-Za-z0-9_+/-]*$/u.test(value))
    return undefined;
  try {
    return new Intl.DateTimeFormat('en-US', { timeZone: value }).resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}

export function effectiveChatTimeZone(client: unknown, workspace: unknown): string | undefined {
  return validChatTimeZone(client) ?? validChatTimeZone(workspace);
}

/** Capture once for a new durable turn; retries reuse the saved request. */
export function browserChatTimeZone(): string | undefined {
  try {
    return validChatTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return undefined;
  }
}
